import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "rounded relative border p-4 pb-16 mb-6" }

import { inject, onMounted, ref, watch } from 'vue'
import { 
    IonSelect,
    IonSelectOption,
} from '@ionic/vue'
import BlockHeader from '@/components/layout/BlockHeader.vue'
import { User } from '@/interfaces/types/UserInterfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'KewContactsBlock',
  emits: [
        'changeMade',
    ],
  setup(__props, { emit: __emit }) {

const emit = __emit

const pageData = inject('data') as any;

const klUsers = ref<User[]>([]);

function filterKlUsers() {
    klUsers.value = pageData.kl_users.filter((user: User) => {
        return user.branches.includes(pageData.data.branch_id) || user.type === 'admin';
    });
}

watch(() => [pageData.data.branch_id,
            pageData.data.assigned_user_id], () => {
            emit('changeMade');
});

onMounted(() => {
    if(pageData.data.branch_id) {
        filterKlUsers();
    }
});


return (_ctx: any,_cache: any) => {
  const _component_input_wrapper = _resolveComponent("input-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BlockHeader, { heading: "Kew Law" }),
    _createVNode(_component_input_wrapper, { label: "Branch" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSelect), {
          placeholder: "Select Branch",
          onIonChange: _cache[0] || (_cache[0] = ($event: any) => (filterKlUsers())),
          value: _unref(pageData).data.branch_id,
          modelValue: _unref(pageData).data.branch_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pageData).data.branch_id) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelectOption), { value: "" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("None", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).branches, (branch, index) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: index,
                value: branch.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(branch.name), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_input_wrapper, {
      label: "Assigned User",
      error: _unref(pageData).errors.assigned_user_id
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSelect), {
          disabled: !_unref(pageData).data.branch_id,
          placeholder: "Select User",
          value: _unref(pageData).data.assigned_user_id,
          modelValue: _unref(pageData).data.assigned_user_id,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pageData).data.assigned_user_id) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelectOption), { value: "" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("None", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(klUsers.value, (user, index) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: index,
                value: user.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.full_name), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled", "value", "modelValue"])
      ]),
      _: 1
    }, 8, ["error"])
  ]))
}
}

})